import styled from 'styled-components';

export const FormMultiTermsWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
    margin-bottom: 24px;
`;

export const AlertWrapper = styled.div`
    .MuiAlert-root {
        margin: 0;
    }
`;

export const CancelButtonWrapper = styled.div`
    margin-right: 12px;
    display: flex;
    align-content: center;
`;

export const ButtonsWrapper = styled.div`
    display: flex;
    justify-content: end;
    height: 44px;
`;
